import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { AdminMessageModel, GameConfigModel, LoginResponse, User, UserDepositBonusConfigModel, UserStatisticsModel, UserWalletModel } from 'mvppoker-portal-common/api'

export interface AppConfig {
	preferredDeck: number
	imageProfileLastUpdate?: number
	gameConfig?: GameConfigModel
	appVersion?: string
	adminMessage?: AdminMessageModel,
	usersOnline: number
	preferredCamera?: string
}

const initialState: AppConfig = {
	preferredDeck: 3,
	usersOnline: 0
}

export const appConfigSlice = createSlice({
	name: 'AppConfig',
	initialState,
	reducers: {
		setPreferredDeck: (state, action: PayloadAction<number>) => {
			state.preferredDeck = action.payload
		},
		setImageProfileLastUpdate: (state, action: PayloadAction<number>) => {
			state.imageProfileLastUpdate = action.payload
		},
		setGameConfig: (state, action: PayloadAction<GameConfigModel>) => {
			state.gameConfig = action.payload
			state.adminMessage = action.payload.adminMessage
		},
		setAppVersion: (state, action: PayloadAction<string>) => {
			state.appVersion = action.payload
		},
		setAdminMessage: (state, action: PayloadAction<AdminMessageModel>) => {
			state.adminMessage = action.payload
		},
		setUsersOnline: (state, action: PayloadAction<number>) => {
			state.usersOnline = action.payload
		},
		setPreferredCamera: (state, action: PayloadAction<string | undefined>) => {
			state.preferredCamera = action.payload
		},
	},
})

export const { setPreferredDeck, setImageProfileLastUpdate, setGameConfig, setAppVersion, setAdminMessage, setUsersOnline, setPreferredCamera } = appConfigSlice.actions

export default appConfigSlice.reducer
